// extracted by mini-css-extract-plugin
module.exports = {"container":"g4","image":"g5","title":"g6","date":"g7"};